import React from 'react';


/**
 * ToolbarSeparator
 */
export default class ToolbarSeparator extends React.Component {

    render() {
        return (
            <div className="separator" style={this.props.style}>|</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/toolbar/ToolbarSeparator.js